interface StarIconOutlinedProps {
  className?: string;
  color?: string;
  size?: "sm" | "md" | "lg" | "xl";
}

export const StarIconOutlined = ({
  className = "",
  color = "currentColor",
  size = "md",
}: StarIconOutlinedProps) => {
  const sizeClasses = {
    sm: "w-4 h-4",  // ~16x16px
    md: "w-6 h-6",  // ~24x24px (approx for 27x26 viewBox)
    lg: "w-8 h-8",  // ~32x32px
    xl: "w-10 h-10", // ~40x40px
  };

  return (
    <div className="icon star-icon__outlined">
      <svg
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 27 26"
        fill="none"
        className={`${sizeClasses[size]} ${className}`}
        aria-hidden="true"
      >
        <path
          d="M5.38281 24.9297C5.14062 24.75 4.99219 24.5078 4.9375 24.2031C4.89062 23.8984 4.94141 23.5352 5.08984 23.1133L7.53906 15.8242L1.28125 11.3242C0.914062 11.0664 0.660156 10.8008 0.519531 10.5273C0.378906 10.2539 0.355469 9.97266 0.449219 9.68359C0.542969 9.40234 0.726562 9.19141 1 9.05078C1.27344 8.91016 1.63672 8.84375 2.08984 8.85156L9.76562 8.89844L12.0977 1.57422C12.2383 1.14453 12.4141 0.820313 12.625 0.601562C12.8438 0.382812 13.1016 0.273438 13.3984 0.273438C13.7031 0.273438 13.9609 0.382812 14.1719 0.601562C14.3906 0.820313 14.5703 1.14453 14.7109 1.57422L17.043 8.89844L24.7188 8.85156C25.1719 8.84375 25.5352 8.91016 25.8086 9.05078C26.082 9.19141 26.2656 9.40234 26.3594 9.68359C26.4531 9.97266 26.4297 10.2539 26.2891 10.5273C26.1484 10.8008 25.8945 11.0664 25.5273 11.3242L19.2695 15.8242L21.7188 23.1133C21.8672 23.5352 21.9141 23.8984 21.8594 24.2031C21.8125 24.5078 21.668 24.75 21.4258 24.9297C21.1836 25.1172 20.9102 25.1797 20.6055 25.1172C20.3008 25.0625 19.9688 24.9062 19.6094 24.6484L13.3984 20.0898L7.19922 24.6484C6.83984 24.9062 6.50781 25.0625 6.20312 25.1172C5.89844 25.1797 5.625 25.1172 5.38281 24.9297ZM7.07031 22.6094C7.08594 22.6328 7.12109 22.625 7.17578 22.5859L12.8125 18.2852C13 18.1367 13.1953 18.0625 13.3984 18.0625C13.6094 18.0625 13.8086 18.1367 13.9961 18.2852L19.6328 22.5859C19.6875 22.625 19.7227 22.6328 19.7383 22.6094C19.7461 22.5938 19.7461 22.5586 19.7383 22.5039L17.4062 15.8008C17.3516 15.6523 17.3242 15.5117 17.3242 15.3789C17.332 15.2461 17.3711 15.125 17.4414 15.0156C17.5117 14.8984 17.6133 14.793 17.7461 14.6992L23.582 10.668C23.6367 10.6367 23.6562 10.6055 23.6406 10.5742C23.6328 10.5508 23.5977 10.5391 23.5352 10.5391L16.4453 10.668C16.2031 10.6758 16.0039 10.6289 15.8477 10.5273C15.6914 10.418 15.5781 10.2422 15.5078 10L13.4688 3.21484C13.4531 3.15234 13.4297 3.12109 13.3984 3.12109C13.375 3.12109 13.3555 3.15234 13.3398 3.21484L11.3008 10C11.2305 10.2422 11.1172 10.418 10.9609 10.5273C10.8047 10.6289 10.6055 10.6758 10.3633 10.668L3.27344 10.5391C3.21094 10.5391 3.17578 10.5508 3.16797 10.5742C3.15234 10.6055 3.17188 10.6367 3.22656 10.668L9.0625 14.6992C9.19531 14.793 9.29688 14.8984 9.36719 15.0156C9.4375 15.125 9.47266 15.2461 9.47266 15.3789C9.48047 15.5117 9.45703 15.6523 9.40234 15.8008L7.07031 22.5039C7.05469 22.5586 7.05469 22.5938 7.07031 22.6094Z"
          fill={color}
        />
      </svg>
    </div>
  );
};


